import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Styles from './styled';
import TextInput from '../Inputs/Text';
import Dropdown from '../Inputs/Dropdown';
import SearchIcon from '../Icons/Search';
import LoadingIcon from '../Icons/Loading';
import CloseIcon from '../Icons/close';
import noop from '../../../util/noop';

const categories = [
  {
    label: 'View All',
    value: 'all',
  },
  {
    label: 'Budgeting',
    value: 'Budgeting',
  },
  {
    label: 'Home Buying',
    value: 'Home Buying',
  },
  {
    label: 'Home Owning',
    value: 'Home Owning',
  },
  // {
  //   label: 'News',
  //   value: 'News',
  // },
];

const PostsFilters = ({
  updateFilter = noop,
  filters: { category = 'all', search = '' },
  isSearching,
  showCategories = true,
}) => {
  const inputRef = useRef();
  const clearSearch = e => {
    updateFilter({ search: '' });

    e.preventDefault();
    e.stopPropagation();

    const field =
      e.target.parentNode.parentNode.querySelector('input[type="text"]');
    setTimeout(() => {
      field?.focus();
    }, 10);
  };
  return (
    <Styles>
      <div className='inner'>
        <div className='categories'>
          {showCategories && (
            <Dropdown
              type='text'
              value={category}
              touched
              onChange={({ value }) => {
                if (value === 'all') {
                  updateFilter({ category: value, search: '' });
                } else {
                  updateFilter({ category: value });
                }
              }}
              values={categories}
              isButton={true}
            />
          )}
        </div>
        <div className='search'>
          <TextInput
            className='full-text'
            type='text'
            value={search}
            touched={!!search}
            onChange={({ value }) => updateFilter({ search: value })}
            placeholder='Search'
          />
          <TextInput
            className='short-text'
            type='text'
            value={search}
            touched={!!search}
            onChange={({ value }) => updateFilter({ search: value })}
            placeholder='Search'
          />

          {isSearching && <LoadingIcon />}

          {!isSearching && !search && <SearchIcon />}

          {!isSearching && search && (
            <button type='button' aria-label='close' onClick={clearSearch}>
              <CloseIcon />
            </button>
          )}
        </div>
      </div>
    </Styles>
  );
};

PostsFilters.propTypes = {
  updateFilter: PropTypes.func,
  filters: PropTypes.shape({
    category: PropTypes.string,
    search: PropTypes.string,
  }),
  isSearching: PropTypes.bool,
};

export default PostsFilters;
